<template>
    <b-row>
        <b-col cols="12"
               lg="12"
               class="settings-header">
            <h3>Profile settings</h3>
        </b-col>
        <user-data></user-data>
        <user-password></user-password>
    </b-row>
</template>

<script>
    import UserData from './settings/UserData.vue'
    import UserPassword from './settings/UserPassword.vue'

    export default {
        components: { UserData, UserPassword }
    }
</script>

<style lang="scss">
    .settings-header{
        margin: 30px 0 70px;
    }

    @media(max-width:991px){
      .settings-header{
        margin: 30px 0 30px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/Settings.vue